const fromEntries = (entries) => {
  return entries.reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {});
};

export { fromEntries };
//# sourceMappingURL=fromEntries.es.js.map
